import classnames from 'classnames';

import { CONNECTION_PLUGINS_STEP_TWO } from 'constants/plugins';
import { CONNECT_PLUGIN_MODAL } from 'constants/connect-plugin';
import { useModal } from 'contexts/modalProvider.context';

import { BannerContent } from 'components/Banner/Banner';
import PopupGuideModal from 'components/Chats/components/PopupGuideModal/PopupGuideModal';

import { ReactComponent as SllrLogo } from 'assets/icons/SllrLogo.svg';
import { ReactComponent as RepeatIcon } from 'assets/icons/repeat.svg';
import { ReactComponent as Info } from 'assets/bosta-icons/Info-Circle.svg';

import './ConnectionSecondStep.less';

const ConnectionFirstStep = ({ intl, data: { platform, isPopupBlocked } }) => {
  const { formatMessage } = intl;
  const { openModal } = useModal();

  const setUpConnectionModal =
    CONNECT_PLUGIN_MODAL[platform?.keyName?.toUpperCase()];

  const handleOpenPopupModal = () => {
    openModal(PopupGuideModal, {});
  };

  return (
    <div className="br-connection-second-step__body-container">
      {isPopupBlocked && (
        <BannerContent
          title={intl.formatMessage({
            id: `chats_plugins.chats_page.popup_note`
          })}
          type="info"
          icon={<Info />}
          buttonText={intl.formatMessage({
            id: `chats_plugins.chats_page.popup_action`
          })}
          buttonProps={{
            onClick: handleOpenPopupModal,
            type: 'basic',
            className: 'button'
          }}
        />
      )}
      <div className="br-connection-second-step__icons-section">
        <SllrLogo />
        <RepeatIcon />
        {setUpConnectionModal.icon}
      </div>
      <div className="br-connection-second-step__description body-medium">
        <span>
          {formatMessage({
            id: setUpConnectionModal.follow_steps
          })}
        </span>
      </div>
      <div className="br-connection-second-step__steps">
        <div className="br-connection-second-step__steps__title text-gray subheading">
          {formatMessage({
            id: setUpConnectionModal.sub_title
          })}
        </div>
        <div className="br-connection-second-step__connection-steps">
          {CONNECTION_PLUGINS_STEP_TWO[platform?.keyName?.toUpperCase()].map(
            ({ id, title }) => (
              <div
                key={id}
                className="br-connection-second-step__connection-steps--content"
              >
                <span
                  className={classnames(
                    'br-connection-second-step__connection-steps--id text-gray'
                  )}
                >
                  {id}
                </span>
                <span className="br-connection-second-step__connection-steps--title">
                  {title}
                </span>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectionFirstStep;
